import vars from '../globals';

import lifehack1 from './lifehacks/lifehack-1';
import lifehack2 from './lifehacks/lifehack-2';
import lifehack3 from './lifehacks/lifehack-3';
import lifehack4 from './lifehacks/lifehack-4';
import lifehack5 from './lifehacks/lifehack-5';
import lifehack6 from './lifehacks/lifehack-6';

let animationState = false;

const destroyMainLifehacksAnimation = () => {
	TweenMax.killTweensOf([$('.lifehack__image-icon')]);
	TweenMax.set([$('.lifehack__image-icon')], {clearProps: 'all'});

	animationState = false;
};

const initMainLifehacksAnimation = () => {
	vars.$window.off('.lifehacks');

	if (!vars.isMobile()) {
		lifehack1(
			$('.lifehack__image-icon--lifehack-1-star'),
			$('.lifehack__image-icon--lifehack-1-nose')
		);

		lifehack2(
			$('.lifehack__image-icon--lifehack-2-star'),
			$('.lifehack__image-icon--lifehack-2-backstar'),
			$('.lifehack__image-icon--lifehack-2-ball')
		);

		lifehack3(
			$('.lifehack__image-icon--lifehack-3-star'),
			$('.lifehack__image-icon--lifehack-3-backstar'),
			$('.lifehack__image-icon--lifehack-3-dot-1'),
			$('.lifehack__image-icon--lifehack-3-dot-2'),
			$('.lifehack__image-icon--lifehack-3-dot-3')
		);

		lifehack4(
			$('.lifehack__image-icon--lifehack-4-money'),
			$('.lifehack__image-icon--lifehack-4-nose'),
			$('.lifehack__image-icon--lifehack-4-eye-open-left')
		);

		lifehack5(
			$('.lifehack__image-icon--lifehack-5-star'),
			$('.lifehack__image-icon--lifehack-5-o')
		);

		lifehack6(
			$('.lifehack__image-icon--lifehack-6-arrow'),
			$('.lifehack__image-icon--lifehack-6-o')
		);

		animationState = true;
	}

	let resizeTimeout = null;

	vars.$window.on('resize.lifehacks', () => {
		if (resizeTimeout) {
			clearTimeout(resizeTimeout);
		}

		resizeTimeout = setTimeout(() => {
			if (!vars.isMobile() && !animationState) {
				initMainLifehacksAnimation();
			} else if (vars.isMobile() && animationState) {
				destroyMainLifehacksAnimation();
			}
		}, 500);
	});
};

export {
	initMainLifehacksAnimation,
	destroyMainLifehacksAnimation,
};
